// import { useEffect } from 'react'
// import { RiArrowDownSLine } from 'react-icons/ri';
// import searchIcon from "../../../assets/admin/search.svg";

// const AddressProvinceField = (props) => {
//     const {
//         index,
//         handleProvinceSelection,
//         toggleDropdownProvince,
//         showOptionProvince,
//         setShowOptionProvince,
//         selectedProvince,

//         setSearchQueryProvince,
//         searchQueryProvince,
//         filteredProvinceList,
//         allProvinceData
//     } = props;

//     // useEffect(() => {
//     //     const handleOutsideClick = (event) => {
//     //         if (!event.target.closest(".dropdown-container")) {
//     //             setShowOptionProvince({ destination_province: false });
//     //         }
//     //     };
//     //     document.addEventListener("click", handleOutsideClick);
//     //     return () => {
//     //         document.removeEventListener("click", handleOutsideClick);
//     //     };
//     // }, []);
// console.log(setShowOptionProvince, "setShowOptionProvince")



//     const dropdownKey = `province-${index}`; 

//     useEffect(() => {
//         const handleOutsideClick = (event) => {
//             if (!event.target.closest(`.dropdown-container-${index}`)) {
//                 setShowOptionProvince(prev => ({
//                     ...prev,
//                     [dropdownKey]: false
//                 }));
//             }
//         };
//         document.addEventListener("click", handleOutsideClick);
//         return () => document.removeEventListener("click", handleOutsideClick);
//     }, [index, dropdownKey, setShowOptionProvince]);


//     return (
//         <div className="flex flex-col md:w-[23%] w-full gap-3">
//             <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
//                 Provincia
//             </label>
//             <div className="flex flex-col w-full space-y-3 dropdown-container">
//                 <div className="relative group w-full">
//                     <button
//                         className={`${showOptionProvince[dropdownKey] ? "border-b-0 rounded-tl-3xl rounded-tr-3xl" : "rounded-full"} border  font-medium
//                                                 border-[#d5d6d9]
//                                                  inline-flex justify-between items-center w-full px-4 py-[8px]  outline-none text-[#6B6B6B] shadow-sm relative z-30 text-xs text-[#8B8B8B]`}
//                         onClick={() => toggleDropdownProvince("destination_province")}
//                     >
//                         <span className="mr-2 flex items-center gap-3 poppins-medium">
//                             {selectedProvince && allProvinceData?.length
//                                 ? allProvinceData.find((item) => item.code === selectedProvince)?.name || "Provincia"
//                                 : "Provincia"}
//                         </span>

//                         <RiArrowDownSLine
//                             className={`transform transition-transform duration-300 ${showOptionProvince[dropdownKey]  ? "rotate-180" : ""
//                                 }`}
//                             size={"24px"}
//                             color="#9f414f"
//                         />
//                     </button>
//                     <div
//                         className={`${showOptionProvince[dropdownKey]  ? "opacity-100 z-50 visible" : "opacity-0 z-20 overflow-hidden invisible"
//                             } bg-[#FFFFFF] h-[200px]
//                                                     border-[#d5d6d9]  absolute pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border transition-all duration-300 ease-in-out`}
//                     >
//                         <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[28px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
//                             <img
//                                 src={searchIcon}
//                                 className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
//                                 alt="Search"
//                             />
//                             <input
//                                 type="text"
//                                 className="block poppins-regular  bg-transparent outline-none w-full placeholder:text-sm" placeholder="Provincia"
//                                 value={searchQueryProvince || ""}
//                                 onChange={(e) => setSearchQueryProvince(e.target.value)}
//                             />
//                         </div>
//                         <div className="max-h-[130px] overflow-y-auto btn-all-yscroll">
//                             {filteredProvinceList && filteredProvinceList.length > 0 ?
//                                 filteredProvinceList.map((option) => (
//                                     <div className="flex gap-[20px]" key={option.id}>
//                                         <label
//                                             className="px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn"
//                                         >
//                                             <input
//                                                 type="checkbox"
//                                                 className="outline-none cursor-pointer"
//                                                 checked={selectedProvince === option.code}
//                                                 onChange={() => handleProvinceSelection(option.code)}
//                                             />
//                                         </label>
//                                         <span className="text-xs text-[#8B8B8B] rounded-md flex items-center poppins-regular">
//                                             {option.name}
//                                         </span>
//                                     </div>
//                                 )) : (
//                                     <div className="flex items-center justify-center p-5">
//                                         <span className="text-xs text-[#8B8B8B] rounded-md flex items-center poppins-regular">
//                                             No Options
//                                         </span>
//                                     </div>
//                                 )}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default AddressProvinceField




import { useEffect } from 'react';
import { RiArrowDownSLine } from 'react-icons/ri';
import searchIcon from "../../../assets/admin/search.svg";

import PropTypes from 'prop-types';

const AddressProvinceField = (props) => {
    const {
        index,
        handleProvinceSelection,
        toggleDropdownProvince,
        showOptionProvince,
        setShowOptionProvince,
        selectedProvince,
        setSearchQueryProvince,
        searchQueryProvince,
        filteredProvinceList,
        allProvinceData
    } = props;

    const dropdownKey = `province-${index}`;

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest(`.dropdown-container-${index}`)) {
                setShowOptionProvince(prev => ({
                    ...prev,
                    [dropdownKey]: false
                }));
            }
        };
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, [index, dropdownKey, setShowOptionProvince]);

    const currentProvinceName = selectedProvince && allProvinceData?.length
        ? allProvinceData.find(item => item.code === selectedProvince)?.name
        : "Provincia";


    return (
        <div className="flex flex-col md:w-[23%] w-full gap-3">
            <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                Provincia
            </label>
            <div className={`flex flex-col w-full space-y-3 dropdown-container-${index}`}>
                <div className="relative group w-full">
                    <button
                        className={`${showOptionProvince[dropdownKey]
                            ? "border-b-0 rounded-tl-3xl rounded-tr-3xl"
                            : "rounded-full"
                            } border font-medium border-[#d5d6d9] inline-flex justify-between items-center w-full px-4 py-[8px] outline-none shadow-sm relative z-30 text-xs text-[#8B8B8B]`}
                        onClick={() => toggleDropdownProvince(dropdownKey)}
                    >
                        <span className="mr-2 flex items-center gap-3 poppins-medium">
                            {currentProvinceName}
                        </span>
                        <RiArrowDownSLine
                            className={`transform transition-transform duration-300 ${showOptionProvince[dropdownKey] ? "rotate-180" : ""
                                }`}
                            size={24}
                            color="#9f414f"
                        />
                    </button>
                    <div
                        className={`${showOptionProvince[dropdownKey]
                            ? "opacity-100 z-50 visible"
                            : "opacity-0 z-20 overflow-hidden invisible"
                            } bg-white h-[200px] border-[#d5d6d9] absolute pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border transition-all duration-300 ease-in-out`}
                    >
                        <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[28px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                            <img
                                src={searchIcon}
                                className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                                alt="Search"
                            />
                            <input
                                type="text"
                                className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                                placeholder="Provincia"
                                value={searchQueryProvince || ""}
                                onChange={(e) => setSearchQueryProvince(e.target.value)}
                            />
                        </div>
                        <div className="max-h-[130px] overflow-y-auto btn-all-yscroll">
                            {filteredProvinceList?.length > 0 ? (
                                filteredProvinceList.map(option => (
                                    <div className="flex gap-[20px]" key={option.id}>
                                        <label className="px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn">
                                            <input
                                                type="radio"
                                                className="outline-none cursor-pointer"
                                                checked={selectedProvince === option.code}
                                                onChange={() => handleProvinceSelection(option.code)}
                                            />
                                            {/* <span className="text-xs text-[#8B8B8B] rounded-md flex items-center poppins-regular">
                                                {option.name}
                                            </span> */}
                                        </label>
                                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center poppins-regular">
                                            {option.name}
                                        </span>
                                    </div>
                                ))
                            ) : (
                                <div className="flex items-center justify-center p-5">
                                    <span className="text-xs text-[#8B8B8B] rounded-md flex items-center poppins-regular">
                                        No Options
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
AddressProvinceField.propTypes = {
    index: PropTypes.number.isRequired,
    handleProvinceSelection: PropTypes.func.isRequired,
    toggleDropdownProvince: PropTypes.func.isRequired,
    showOptionProvince: PropTypes.object.isRequired,
    setShowOptionProvince: PropTypes.func.isRequired,
    selectedProvince: PropTypes.string,
    setSearchQueryProvince: PropTypes.func.isRequired,
    searchQueryProvince: PropTypes.string,
    filteredProvinceList: PropTypes.array.isRequired,
    allProvinceData: PropTypes.array.isRequired,
};

export default AddressProvinceField;



// {filteredProvinceList.map((option) => (
//     <div key={option.id} className="flex items-center py-2 px-1 hover:bg-gray-50">
//         <button
//             type="button"
//             className={`w-4 h-4 rounded-full border-2 mr-3 flex items-center justify-center
//             ${selectedProvince === option.code
//                     ? 'border-[#9f414f] bg-[#9f414f]'
//                     : 'border-gray-300'}`}
//             onClick={() => handleProvinceSelection(option.code)}
//         >
//             {selectedProvince === option.code && (
//                 <div className="w-2 h-2 rounded-full bg-white"></div>
//             )}
//         </button>
//         <span className="text-xs text-[#8B8B8B] poppins-regular">
//             {option.name}
//         </span>
//     </div>
// ))}

